import push from '../utils/routing';
import Parse from '../utils/parse';
import { deleteCookie } from '../../core/utils/cookie';

// PROVISIONAL!!!
const errorObserver = (store) => {
  let currentState = null;

  const handleChange = () => {
    const nextState = store.getState().errors;
    const pathState = store.getState().routing.locationBeforeTransitions;
    const { isLogged } = store.getState().user;
    const { isLoggingOut } = store.getState().user;

    if (nextState !== currentState && nextState && nextState) {
      currentState = nextState;
      if (
        nextState.last &&
        nextState.last.error &&
        nextState.last.error.code === 209 &&
        pathState.pathname !== '/signin/login' &&
        isLogged &&
        !isLoggingOut
      ) {
        Parse.User.logOut().then(() => {
          deleteCookie('ub-logged', '', '.aula.education');
          push('/signin/login');
          store.dispatch({
            type: 'USER_LOGOUT',
            status: 'success',
          });
        });
      }
    }
  };

  const unsubscribe = store.subscribe(handleChange);
  handleChange();

  return unsubscribe;
};

export default errorObserver;
